import React, { Component } from "react";
import { Link, useLocation } from "react-router-dom";
import { navigation } from "../data/constant";

let NAV_ITEMS = [];

class TopNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const user = window.localStorage.getItem("user_params");
    if (user) this.getNav(user);
  }

  getNav = (payload) => {
    const user = JSON.parse(payload);
    const { tabs } = user.roles[0];

    NAV_ITEMS = navigation.filter((nav) => {
      return tabs.some((tab) => tab.url.split("cc.krgsc.kz")[1] === nav.link);
    });

    this.forceUpdate();
  };

  renderNav = (nav, currentPath) => {
    return (
      <ul>
        {nav.map((el, index) => (
          <li key={index} className={el.link === currentPath ? "active" : ""}>
            <Link to={el.link}>
              <img src={`${el.icon}.png`} alt="navigation" className="dark" />
              <img
                src={`${el.icon},1.png`}
                alt="navigation"
                className="white"
              />
              <h3 className="activeText">{el.title}</h3>
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { currentPath } = this.props; // Получаем currentPath из пропсов
    return (
      <nav>
        {this.renderNav(NAV_ITEMS.slice(0, 4), currentPath)}
        {this.renderNav(NAV_ITEMS.slice(4, 8), currentPath)}
        {this.renderNav(NAV_ITEMS.slice(8, 12), currentPath)}
        {this.renderNav(NAV_ITEMS.slice(12, NAV_ITEMS.length), currentPath)}
      </nav>
    );
  }
}

// Обертка для передачи currentPath через useLocation
const TopNavigationWithLocation = () => {
  const location = useLocation(); // Получаем текущий путь
  return <TopNavigation currentPath={location.pathname} />;
};

export default TopNavigationWithLocation;
